import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-complex-settings',
  templateUrl: './complex-settings.component.html',
  styleUrls: ['./complex-settings.component.less']
})
export class ComplexSettingsComponent implements OnInit {

  constructor() { }

  @Input()
  property:any;
  
  guidData:any;

  ngOnInit() {
  }

  
 
}
